export default "__VITE_ASSET__DtsgsQz0__"